 <neo-campo-boolean-palanca-model
   id="modoVista-lg"
   [texto]="'Cambiar tipo de vista'"
   [iconoClase]="'modoVista toggle-icon toggle-list-table'"
   [color]="'primary'"
   [valor]="(proyectosService.modoVista$ | async)"
   (nuevoValor)="aplicarCambiarVista($event)">
</neo-campo-boolean-palanca-model>

